import { useContext } from 'react';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { CompareContext } from '../../context/compare.context';
import { MAX_COMPARE } from '../../utils/compare.utils';

// Caixinha "Comparar" que aparece em cada plano dos resultados.
const CompareToggle = ({ insurance }) => {
  const { compareList, isInCompare, toggleCompare } = useContext(CompareContext);
  const checked = isInCompare(insurance);
  const full = !checked && compareList.length >= MAX_COMPARE;

  return (
    <Tooltip title={full ? `Você pode comparar até ${MAX_COMPARE} planos por vez.` : ''}>
      <FormControlLabel
        label="Comparar"
        disabled={full}
        control={
          <Checkbox size="small" checked={checked} onChange={() => toggleCompare(insurance)} />
        }
        sx={{
          m: 0,
          '& .MuiFormControlLabel-label': { fontSize: '0.875rem', fontWeight: 600 },
        }}
      />
    </Tooltip>
  );
};

export default CompareToggle;
